/**
 * Ce qu'on dit quand une caméra ne s'ouvre pas, et comment on l'éteint.
 *
 * Partagé par la webcam de l'interprète et la page du téléphone : les refus du
 * navigateur sont les mêmes des deux côtés, et une phrase recopiée finit par
 * dire deux choses différentes du même refus.
 */

export function describeCameraFailure(error: unknown): string {
  // Sans contexte sécurisé, `navigator.mediaDevices` n'existe pas et l'appel
  // lève un `TypeError` : c'est l'adresse qui est en cause, pas la caméra.
  if (error instanceof TypeError) {
    return "Ce navigateur ne donne pas accès à la caméra sur cette adresse. Ouvre le lien en https.";
  }

  const name = error instanceof Error ? error.name : "";

  if (name === "NotAllowedError" || name === "SecurityError") {
    return "Le navigateur a refusé la caméra. Autorise-la pour ce site dans ses réglages, puis réessaie.";
  }

  if (name === "NotFoundError" || name === "OverconstrainedError") {
    return "Aucune caméra n'a été trouvée sur cet appareil.";
  }

  if (name === "NotReadableError" || name === "AbortError") {
    return "La caméra est déjà utilisée par une autre application.";
  }

  return "La caméra n'a pas pu s'ouvrir.";
}

/** Arrête toutes les pistes d'un flux : c'est ce qui éteint le voyant de la caméra. */
export function stopTracks(stream: MediaStream): void {
  for (const track of stream.getTracks()) {
    track.stop();
  }
}
